import type { InjectionKey } from 'vue'
import truncate from '@app/utils/truncate'

export const IN_COMMENT: InjectionKey<boolean> = Symbol('inComment')

interface Attachment {
  id: number
  filename: string
  url: string
}

export function pickAttachmentsByIds(
  attachmentArray: Attachment[],
  attachmentIds: number[]
): Attachment[] {
  const attachments = []
  for (const a of attachmentArray) {
    if (a && attachmentIds.includes(a.id)) {
      attachments.push({ ...a, filename: truncate(a.filename) })
    }
  }
  return attachments
}
